import { lazyLaunchInAppFeedback } from 'owa-uservoice';
import { getSupportTicketMetaBlob } from '../utils/getSupportTicketMetaBlob';
import { trace } from 'owa-trace';
import * as HelpCharmConstants from '../utils/HelpCharmConstants';
import extractAndSendDiagnosticsInfoToODS from '../utils/extractAndSendDiagnosticsInfoToODS';
import { getGuid } from 'owa-guid';

const socOriginUrl = 'https://support.office.com';
const invokeFeedbackEvent = 'InvokeFeedback';
const requestMetadataEvent = 'RequestMetadata';

export default async function handleSocPostMessageEvents(messageEvent: any) {
    if (messageEvent.origin == socOriginUrl) {
        trace.info('Soc post message event: ' + messageEvent.data);
        if (messageEvent.data == invokeFeedbackEvent) {
            lazyLaunchInAppFeedback.importAndExecute();
        } else if (messageEvent.data == requestMetadataEvent) {
            let supportTicketMetaBlob = await getSupportTicketMetaBlob();
            messageEvent.source.postMessage(supportTicketMetaBlob, socOriginUrl);
        } else if (messageEvent.data.indexOf(HelpCharmConstants.OsefoTicketCreatedEvent) > -1) {
            extractAndSendDiagnosticsInfoToODS(messageEvent.data, getGuid());
        }
    }
}
